import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserScreener = React.lazy(() =>
    import('../UserScreener')
);
const userScreenerRoutesRegistry = [
    {
        path: PAGE_URL.USER_SCREENER_PAGE,
        element: <UserScreener />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userScreenerRoutesRegistry;
